import React, { useMemo, useState } from 'react'
import { Grid } from '@material-ui/core'
import { ValidationButton } from '../../common/validation-button'
import { CancelButton } from '../../common/cancel-button'
import { useSelector } from 'react-redux'
import { getFlatThemeComponents } from '../../../store/selectors/component-selectors'
import { Autocomplete } from '../../../dsn-kernel'
import { Types } from '../../../store/constants/fonction/fonction'

function getMap(themes, themeName, param, role) {
  return themes
    .find(t => t.nom === themeName)
    [role].filter(i => Types[param.parametre.type].condition(i, param.parametre))
    .map(i => i.nom)
}

export const RenvoieSelectPath = ({ classes, handleClose, selectedPath, parametre, handleSelection }) => {
  const themes = useSelector(state => getFlatThemeComponents(state))

  const [selectedThemeInit, selectedRoleInit, selectedRoleLabelInit, selectedComposantInit] = useMemo(() => {
    if (selectedPath) {
      let indexOf = selectedPath.indexOf('.')
      let theme = selectedPath.substring(0, indexOf)
      let composant = selectedPath.substring(indexOf + 1)

      let find = themes.find(t => t.nom === theme)
      let list = [...find['inputs'], ...find['outputs']] //.filter(i => Types[param.parametre.type].condition(i, param.parametre));
      let composantObj = list.find(i => i.nom === composant)
      let role = 'inputs'
      let roleLabel = 'INPUT'
      if (composantObj.role.name.startsWith('OUTPUT')) {
        role = 'outputs'
        roleLabel = 'OUTPUT'
      }
      return [theme, role, roleLabel, composant]
    }
    return [null, 'inputs', 'INPUT', null]
  }, [selectedPath])

  const [selectedTheme, setSelectedTheme] = useState(selectedThemeInit)
  const [themeList, setThemeList] = useState(themes.map(t => t.nom))
  const [selectedRoleLabel, setSelectedRoleLabel] = useState(selectedRoleLabelInit)
  const [selectedRole, setSelectedRole] = useState(selectedRoleInit)
  const [selectedComposant, setSelectedComposant] = useState(selectedComposantInit)
  const handleCancel = () => {
    handleClose()
  }
  var onChangeRole = (event, value) => {
    if (value === 'INPUT') {
      setSelectedRole('inputs')
      setSelectedRoleLabel('INPUT')
    } else if (value === 'OUTPUT') {
      setSelectedRole('outputs')
      setSelectedRoleLabel('OUTPUT')
    }
  }
  const composantList = useMemo(() => {
    if (!selectedTheme) return []
    return getMap(themes, selectedTheme, parametre, selectedRole)
  }, [themes, selectedTheme, selectedRole])
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 15, marginBottom: 15 }}>
        <Autocomplete
          name={'theme'}
          label={'Théme'}
          size={'small'}
          value={selectedTheme}
          options={themeList}
          disabled={!themeList.length}
          onChange={(event, value) => setSelectedTheme(value)}
        />
        <Autocomplete
          name={'role'}
          label={'Rôle'}
          size={'small'}
          value={selectedRoleLabel}
          options={['INPUT', 'OUTPUT']}
          disabled={!selectedTheme}
          onChange={onChangeRole}
        />
        <Autocomplete
          name={'composant'}
          label={'Composant'}
          size={'small'}
          value={selectedComposant}
          options={composantList}
          disabled={!selectedTheme}
          onChange={(event, value) => setSelectedComposant(value)}
        />
      </Grid>
      <Grid>
        <ValidationButton
          variant="contained"
          size="medium"
          color="primary"
          disabled={!selectedComposant}
          onClick={() => {
            handleSelection(selectedTheme + '.' + selectedComposant)
            handleCancel()
          }}
          className={classes.margin}
        >
          SELECTIONNER
        </ValidationButton>
      </Grid>
      <Grid>
        <CancelButton
          variant="contained"
          size="medium"
          color="primary"
          onClick={handleCancel}
          className={classes.margin}
        >
          ANNULER
        </CancelButton>
      </Grid>
    </>
  )
}
